import React, { useEffect } from 'react'

interface MessegePopupProps {
    statusMessege: string;
    message: string;
    show: boolean;
    onClose: () => void;
}

const MessegePopup: React.FC<MessegePopupProps> = ({ statusMessege, message, show, onClose }) => {

    useEffect(() => {
        let time = statusMessege === 'שגיאה' ? 8000 : 3000;
        setTimeout(() => {
            onClose();
        }, time);

    }, [message])

    const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    if (!show) return null; // Return null if the modal should not be shown

    return (
        <div
            onClick={handleOverlayClick}
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                // width:'30%',
                // height: 200,
                // backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 1000
            }}>
            <div
                onClick={(e) => e.stopPropagation()} // Prevent click events from reaching the overlay
                style={{
                    width: 270,
                    height: 150,
                    backgroundColor: '#fff',
                    padding: '20px',
                    borderRadius: '5px',
                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                    textAlign: 'center'
                }}>
                {/* create messege for success from server */}
                {statusMessege === 'שגיאה' ? (<p style={{ color: 'red', fontSize: 24 }}>{message + " "}</p>) :
                    (<p style={{ color: 'blue', fontSize: 24 }}>{message}</p>)

                }
            </div>
        </div>
    );
}

export default MessegePopup